const __WEBPACK_NAMESPACE_OBJECT__ = require("@nextcloud/l10n/gettext");